import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

const DeliveryCellComponent = ({ item, labelsStore, uiStore }) => {
  if (uiStore.isMobile) {
    return item.deliveryTime
      ? (
        <>
          <span className="pes-text--colon">{labelsStore.deliveryDaysHeadLabel}</span>
          <span>{item.deliveryTime}</span>
        </>
      )
      : labelsStore.deliveryNotAvailable;
  }

  return item.deliveryTime
    ? item.deliveryTime
    : labelsStore.deliveryNotAvailable;
};

DeliveryCellComponent.propTypes = {
  item: propTypes.shape({
    deliveryTime: propTypes.string
  }).isRequired,

  labelsStore: propTypes.shape({
    deliveryNotAvailable: propTypes.string,
    deliveryDaysHeadLabel: propTypes.string
  }).isRequired,

  uiStore: propTypes.shape({
    isMobile: propTypes.bool
  }).isRequired

};

export const DeliveryCell = inject('labelsStore', 'uiStore')(observer(DeliveryCellComponent));
